import React from "react";
import { Link } from "react-router-dom";
// COMPONENTS
import SiteButton from "Components/WebsiteTheme/SiteButton";
import SiteSectionHead from "Components/WebsiteTheme/SiteSectionHead";
import { IconChevron, ToneIcon } from "Components/WebsiteTheme/SiteIcons";
import { revealProps } from "Components/WebsiteTheme/Reveal";
import { CTA, PLANS } from "Components/WebsiteTheme/site.data";
// STYLES
import { PlansSection } from "./LandingPage.style";

/** Plans That Grow With You: one card per plan, each opening the Subscription page with that plan selected. */
const SubscriptionPlansSection = () => (
	<PlansSection className="sm_section">
		<div className="sm_container">
			<SiteSectionHead
				{...revealProps("up")}
				align="center"
				title="Plans That Grow With You."
				lead="Flexible options for individual educators, homeschool networks, small schools, and larger organizations."
			/>

			<ul className="pl_row">
				{PLANS.map((plan, index) => (
					<li key={plan.key} {...revealProps("up", index)}>
						<Link className={`pl_card sm_tone--${plan.tone}`} to={CTA.plans.to} state={{ plan: plan.key }} onClick={() => window.scrollTo({ top: 0 })}>
							<ToneIcon iconKey={plan.key} tone={plan.tone} solid />
							<span className="pl_copy">
								<span className={`sm_h4 pl_title--${plan.tone}`}>{plan.title}</span>
								<span className="sm_small">{plan.text}</span>
							</span>
							<IconChevron className="pl_chev" />
						</Link>
					</li>
				))}
				<li className="pl_action">
					<SiteButton to={CTA.plans.to} variant="outline">
						{CTA.plans.label}
					</SiteButton>
				</li>
			</ul>
		</div>
	</PlansSection>
);

export default SubscriptionPlansSection;
